<template>
  <div id="projectDetail">
    
      <!-- Card -->
      
        <!-- Spinner -->
        <loading :active.sync="loading"></loading>
        <!-- /Spinner -->
        <!-- Form -->
        <project-form ref="projectForm" @isChangedForm="(value) => isChangedForm = value" :id="this.id" @load="load" @set-chat="setProject" />
        <!-- /Form -->
      
      <!-- /Card -->

      <div class="chatter-btn-wrap" :class="{ 'bottom': isPageEnd }">
              <div class="button-container">
                <base-button variant="default" size="sm" @click="cancel">Close</base-button>
                <base-button :disabled="!isChangedForm" variant="primary" @click="update">Update</base-button>
                <!-- <b-button @click="cancel" type="button" class="btn-secondary">Close</b-button>
                <b-button :disabled="!isChangedForm" @click="update" variant="primary" class="btn-primary">Update</b-button> -->
              </div>
        <!-- /Buttons -->
      </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import ProjectForm from './ChatterProjectForm.vue';
import BaseButton from '../requirement/BaseButton.vue';

export default ({
  props: { id: { type: String } },
  components: { Loading, ProjectForm, BaseButton },
  computed: {
    assigneeOptions() {
      return this.$store.getters['chatter/assigneeOptions']
        .filter(status => status.value).slice().sort((a, b) => a.text.localeCompare(b.text));
    },
    projectStatusOptions() {
      return this.$store.getters['chatter/projectStatusOptions']
    },
  },
  data() {
    return {
      project: {
        projectId: '',
        name: '',
        startDate: '',
        endDate: '',
        creatorId: '',
        status: '',
        description: '',
        checkedMethodology: false,
      },
      fileInput: [],
      dateRule: { required: false, regex: /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/ },
      originData: null,
      editStatus: false,
      blStatusDone: false,
      blContentModified: false,
      loading: false,
      // chatter-btn-wrap 페이지 끝 도달 시 클래스 부여 위해 추가함
      isPageEnd: false,
      // 스크롤 시 chatter-top-area의 title 노출 이벤트 위해 추가
      isScrollStart: false,
      isChangedForm: false,
    }
  },
  watch: {
    project: {
      handler() {
        this.blContentModified = true;
      },
      deep: true,
    }
  },
  mounted() {
    // chatter-btn-wrap 페이지 끝 도달 시 클래스 부여 위해 추가함
    window.addEventListener('scroll', this.handleScroll)
    // 스크롤 시 chatter-top-area의 title 노출 이벤트 위해 추가
    window.addEventListener('scroll', this.showTitle)
  },
  // vue.js LifeCycle Hook Event 발생 시점 : 생성된 컴포넌트가 폐기 되는 시점
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);

    // chatter-btn-wrap 페이지 끝 도달 시 클래스 부여 위해 추가함
    window.removeEventListener('scroll', this.handleScroll);
    // 스크롤 시 chatter-top-area의 title 노출 이벤트 위해 추가
    window.removeEventListener('scroll', this.showTitle)
  },
  methods: {
    async load() {
      try {
        this.loading = true;
        await this.$refs.projectForm.load();
      } catch (error) {
        this.loading = false;
        this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    async update() {
      try {
        this.loading = true;
        const {status, message, body} = await this.$refs.projectForm.update();

        if (status === "200") {
          this.showToast("프로젝트가 수정되었습니다.");
          //Update Vuex(update된 project 정보 반영)
          await this.$store.dispatch('chatter/retrieveAllProjectInfo', 'update');
          await this.$refs.projectForm.load();
        } else {
          this.showToast(message, "danger", 2000);
        }
      } catch (error) {
        this.loading = false;
        // error.message === 400 means validation failed
        if (error.message !== '400') {
          this.showToast(error.message, 'danger');
        }
      } finally {
        this.loading = false;
      }
    },
    toast(toaster, append = false) {
      this.counter++
      this.$bvToast.toast(`Toast ${this.counter} body content`, {
        title: ``,
        toaster: toaster,
        solid: true,
        appendToast: append
      })
    },
    setProject(param) {
      this.project.projectId = param.projectId;
      this.project.name = param.name;
      this.project.startDate = param.startDate;
      this.project.endDate = param.endDate;
      this.project.creatorId = param.creatorId;
      this.project.status = param.status;
      this.project.description = param.description;
      this.project.checkedMethodology = param.projectType;
    },
    async cancel() {
      if(this.isChangedForm) {
        if (await this.showConfirm('작성된 내용이 저장되지 않았습니다. 페이지를 이동하시겠습니까?')) {
          this.pushRoute('/chatter/chatter-project-list');
        } else {
          return;
        }
      }
      this.pushRoute('/chatter/chatter-project-list');
    },
    async validate() {
      let errFields = [];
      this.errors.items.forEach((error) => {
        if (this.$refs[error.field] !== undefined) {
          this.$refs[error.field].focus();
        }
        if (error.field === 'content') {
          this.$bvToast.toast(`Comment를 입력해주세요.`, {
            title: `Notification`,
            toaster: "b-toaster-bottom-center",
            solid: true,
            appendToast: false,
            autoHideDelay: 400,
            variant: "danger"
          }
          )
        }
        errFields.push(error.field);
      });
      return errFields;
    },
    // today() {
    //   const date = new Date();
    //   const year = date.getFullYear();
    //   const month = String(date.getMonth() + 1).padStart(2, '0');
    //   const day = String(date.getDate()).padStart(2, '0');
    //   return `${year}-${month}-${day}`;
    // },
    async delete() {
      try {
        this.loading = true;
        // Call submit method of ChatterForm

        await this.$refs.form.delete();
        // Reload
        //await this.$refs.form.load();
        this.$bvToast.toast(`Project가 삭제 되었습니다.`, {
          title: `Notification`,
          toaster: "b-toaster-bottom-center",
          solid: true,
          appendToast: false,
          autoHideDelay: 400
        }
        )
      } catch (error) {
        // error.message === 400 means validation failed
        if (error.message !== '400') {
          this.showError(error);
        }
      } finally {
        this.loading = false;
        this.$forceDelete();
      }

    },

    handleChange() {
      this.blStatusDone = (this.project.status === 'DONE' || this.project.status === 'CANCELLED');
      this.$emit("reply-validation", this.blStatusDone);
    },
    handleScroll() {
      const scrollPosition = document.documentElement.scrollTop;
      if ((scrollPosition + window.innerHeight) >= document.body.scrollHeight) {
        this.isPageEnd = true;
      } else {
        this.isPageEnd = false;
      }
    },
  }
})
</script>

<style>



#projectDetail span.required {
  color: red;
}

#projectDetail .image-title {
  display: block;
  margin-bottom: .3rem;
}

#projectDetail .image-box {
  display: block;
  max-width: 100%;
}

#projectDetail .hide-toolbar .ql-toolbar {
  display: none;
}

#projectDetail .hide-border .ql-container {
  border: none !important;
}

#projectDetail .custom-input {
  height: 2rem !important;
  line-height: 1.0 !important;
}

#projectDetail .custom-tags {
  height: 1.1rem !important;
}

#projectDetail .card-header {
  padding-left: 1rem;
}

#projectDetail .button-container {
  white-space: nowrap;
  /* 텍스트가 줄바꿈되지 않도록 설정 */
  overflow: hidden;
  /* 너비를 초과하는 텍스트를 감추기 */
  margin: 0.2em;
  padding: 0.2em;
}

#projectDetail .btn {
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

#projectDetail .btn:focus {
  box-shadow: none;
}

#projectDetail .btn-primary {
  width: 280px;
  height: 60px;
  background-color: #2E2E38;
  color: #FFE600;
  border-color: transparent;
}

#projectDetail .btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

#projectDetail .btn-primary.disabled,
#projectDetail .btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

#projectDetail .btn-secondary {
  width: 146px;
  height: 60px;
  border-radius: 10px;
  background: #747480;
  color: #fff;
}

#projectDetail .btn-secondary.small {
  height: 40px;
}

#projectDetail .btn-secondary:hover {
  background-color: #565662;
}

#projectDetail .btn-secondary.disabled,
#projectDetail .btn-secondary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

#projectDetail .btn-sub-primary {
  width: 140px;
  height: 60px;
  background-color: #2E2E38;
  border: none;
  color: #FFF;
}

#projectDetail .btn-sub-primary:hover {
  background-color: #0D0D17;
}

#projectDetail .btn-sub-primary.disabled,
#projectDetail .btn-sub-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

#projectDetail .btn-line {
  position: relative;
  width: 100px;
  height: 60px;
  border: 1px solid #C4C4CD;
  background-color: transparent;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  text-align: inherit;
}

#projectDetail .btn-line:hover {
  color: #2E2E38;
  border: 1px solid #2E2E38;
  background-color: transparent;
}

#projectDetail .btn-line.disabled,
#projectDetail .btn-line:disabled {
  border: 1px solid #DDDDE3;
  background-color: transparent;
}

#projectDetail .btn-line.small {
  height: 40px;
}

#projectDetail .btn-line.prev {
  padding: 0 1.866rem 0 2.866rem;
}

#projectDetail .btn-line.prev::before {
  content: '';
  display: block;
  position: absolute;
  left: 1.133rem;
  top: 1.466rem;
  width: 16px;
  height: 16px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.5 2L4.5 8L10.5 14" stroke="%232E2E38" stroke-linecap="round"/></svg>') center no-repeat;
}

#projectDetail .btn-line.prev.disabled::before,
#projectDetail .btn-line.prev:disabled::before {
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.5 2L4.5 8L10.5 14" stroke="%23DDDDE3" stroke-linecap="round"/></svg>') center no-repeat;
}

#projectDetail .btn-line.next {
  padding: 0 2.866rem 0 1.866rem;
}

#projectDetail .btn-line.next::before {
  content: '';
  display: block;
  position: absolute;
  right: 1.133rem;
  top: 1.466rem;
  width: 16px;
  height: 16px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M6 14L12 8L6 2" stroke="%232E2E38" stroke-linecap="round"/></svg>') center no-repeat;
}

#projectDetail .btn-line.next.disabled::before,
#projectDetail .btn-line.next:disabled::before {
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M6 14L12 8L6 2" stroke="%23DDDDE3" stroke-linecap="round"/></svg>') center no-repeat;
}

#projectDetail .btn-delete,
#projectDetail .badge-container .btn-delete {
  width: 16px;
  height: 16px;
  font-size: 0 !important;
  background: transparent url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 12L4 4" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 4L4 12" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center/16px 16px no-repeat;
}

#projectDetail .btn-card-fold {
  position: absolute;
  top: 2rem;
  right: 2.666rem;
  display: block;
  width: 30px;
  height: 30px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M23.75 18.75L15 10L6.25 18.75" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
  border: none;
  z-index: 100;
}

#projectDetail .btn-card-fold.fold {
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M23.75 11.25L15 20L6.25 11.25" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

#projectDetail .chatter-btn-wrap {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: end;
  flex-wrap: wrap;
  padding: 1.333rem 3.125vw;
  gap: 0.666rem;
  align-items: center;
  margin-left: -3.125vw;
  margin-right: -3.125vw;
  z-index: 999;
  background-color: #f6f6fa;
  box-shadow: 0px -10px 30px 0px rgba(46, 46, 56, 0.14);
}

#projectDetail .chatter-btn-wrap.bottom {
  box-shadow: none;
}


#projectDetail .chatter-btn-wrap .button-container {
  display: flex;
  gap: 0 10px;
  margin: 0;
  padding: 0;
}
</style>

